module.exports = __webpack_public_path__ + "static/images/styles/images/table/table-head-cell-sort-up.f3f3b74f.png";


//////////////////
// WEBPACK FOOTER
// ./styles/images/table/table-head-cell-sort-up.png
// module id = 3826
// module chunks = 11